<template>
  <b-form-radio-group
    v-model="preferences.product_list"
    class="display-switch"
    @change="change"
  >
    <b-form-radio value="gallery">
      <i class="fa-solid fa-grid-2" />
    </b-form-radio>
    <b-form-radio value="list">
      <i class="fa-solid fa-list" />
    </b-form-radio>
  </b-form-radio-group>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("user", ["preferences"])
  },
  methods: {
    change(v) {
      this.$store.commit("user/setPreferences", { product_list: v });
      localStorage.setItem("productsDisplay", v);
    }
  }
};
</script>
<style lang="scss" scoped>
.display-switch {
  ::v-deep {
    .custom-radio {
      padding: 0;
      &:has(input:checked) {
        i {
          background-color: #ebebeb;
        }
      }
    }
    .custom-control-inline {
      margin-right: 4px;
    }
    .custom-control-label {
      i {
        padding: 8px;
        border-radius: 2px;
        transition: 0.2s all;
        color: #57586be0;
        cursor: pointer;
        &:hover {
          background-color: #f6f6f6;
        }
      }
      &::before,
      &::after {
        content: unset;
      }
    }
  }
}
</style>
